import Api from '@/services/Api'

export default {
	login (credentials) {
		return Api().post('signin', credentials)
	},
	verifyMfa(form){
		return Api().post('signin/mfa/verify', form)
	},
	resendMfa(form){
		return Api().post('signin/mfa/resend', form)
	},
	validate(token){
		return Api().get('validate?t='+token)
	},
	setPassword(form){
		return Api().put('set-account', form)
	},
	resetPassword(form){
		return Api().put('reset-password', form)
	},
	requestPasswordResetCode(form){
		return Api().post('password-reset/request', form)
	},
	verifyPasswordResetCode(form){
		return Api().post('password-reset/verify', form)
	},
	confirmPasswordReset(form){
		return Api().post('password-reset/confirm', form)
	},
	getPasswordPolicy(){
		return Api().get('password-policy')
	},
	leaParametros(){
		return Api().get('leaParametros')
	},

}
